import React from 'react';

interface SolutionsSectionProps {
  onOpenSimulation?: () => void;
}

export const SolutionsSection: React.FC<SolutionsSectionProps> = ({ onOpenSimulation }) => {
  const solutions = [
    {
      id: 'websites',
      icon: '🌐',
      title: 'Sites que Vendem',
      description: 'Criamos sites modernos e responsivos que convertem visitantes em clientes. Do institucional ao e-commerce completo.',
      features: ['Design moderno', 'Otimizado para Google', 'Responsivo', 'Carregamento rápido']
    },
    {
      id: 'apps',
      icon: '📱',
      title: 'Apps que Funcionam',
      description: 'Desenvolvemos aplicativos mobile para Android e iOS que seus usuários vão amar usar todos os dias.',
      features: ['Android e iOS', 'Interface intuitiva', 'Funciona offline', 'Notificações push']
    },
    {
      id: 'sistemas',
      icon: '⚙️',
      title: 'Sistemas que Simplificam',
      description: 'Automatizamos seus processos com sistemas web personalizados que eliminam trabalho manual e aumentam produtividade.',
      features: ['Totalmente personalizado', 'Integração com outros sistemas', 'Relatórios automáticos', 'Acesso em qualquer lugar']
    },
    {
      id: 'apis',
      icon: '🔗',
      title: 'APIs que Conectam',
      description: 'Integramos seus sistemas e dados com APIs robustas e seguras que fazem tudo funcionar em harmonia.',
      features: ['Integração total', 'Segurança avançada', 'Documentação completa', 'Suporte técnico']
    },
    {
      id: 'automacao',
      icon: '🤖',
      title: 'Automação que Liberta',
      description: 'Automatizamos tarefas repetitivas e processos manuais, liberando sua equipe para focar no que realmente importa.',
      features: ['Processos automáticos', 'Economia de tempo', 'Redução de erros', 'Mais produtividade']
    },
    {
      id: 'consultoria',
      icon: '💡',
      title: 'Consultoria que Transforma',
      description: 'Analisamos seus processos e sugerimos as melhores soluções tecnológicas para impulsionar seu negócio.',
      features: ['Análise completa', 'Estratégia personalizada', 'Implementação guiada', 'Resultados garantidos']
    }
  ];

  return (
    <section className="py-20 bg-slate-800">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
              Soluções Digitais que <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-sky-500">Realmente Funcionam</span>
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Não importa o tamanho da sua empresa ou o desafio que você enfrenta. 
              Temos a solução digital perfeita para levar seu negócio para o próximo nível.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {solutions.map((solution) => (
              <div key={solution.id} className="bg-slate-900 border border-slate-700 p-8 rounded-xl hover:border-teal-500 transition-all duration-300 group">
                <div className="text-4xl mb-4 group-hover:scale-110 transition-transform duration-300">
                  {solution.icon}
                </div>
                <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-teal-400 transition-colors duration-300">
                  {solution.title}
                </h3>
                <p className="text-gray-400 mb-6 leading-relaxed">
                  {solution.description}
                </p>
                <ul className="space-y-2">
                  {solution.features.map((feature, index) => (
                    <li key={index} className="flex items-center text-sm text-gray-300">
                      <span className="text-teal-400 mr-2">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-16">
            <div className="bg-gradient-to-r from-teal-500/10 to-sky-500/10 border border-teal-500/20 p-8 rounded-xl">
              <h3 className="text-2xl font-bold text-white mb-4">
                🚀 Pronto para Transformar seu Negócio?
              </h3>
              <p className="text-gray-400 mb-6">
                Conte para a gente qual é o seu desafio e vamos criar a solução perfeita para você!
              </p>
              <button 
                onClick={onOpenSimulation}
                className="bg-gradient-to-r from-teal-500 to-sky-500 text-white px-8 py-4 rounded-lg font-semibold hover:from-teal-600 hover:to-sky-600 transition-all duration-300 transform hover:scale-105"
              >
                Solicitar Orçamento Gratuito
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};